import React, { useContext } from "react";

// img
import avatar from "../../images/avatar.png";
import { toFarsiNumber } from "../../helper/helper";

import { UserData } from "../../contexts/UserInfoContext";

const ThemeTwo = ({ data }) => {
  const { user, loaded } = useContext(UserData);

  const circle = [1, 2, 3, 4];

  return (
    <div className="theme-two relative min-w-[795px] max-w-[795px] h-auto border m-10 pb-10">
      <div className="theme-two-header absolute h-[50px] w-[20%] left-0"></div>
      <div className="line-1"></div>
      <div className="line-2"></div>
      <div className="line-3"></div>
      <div className="line-4"></div>

      <div className="relative grid grid-cols-7 z-20 pt-12">
        {/* right side */}
        <div className="flex flex-col items-center gap-3 col-span-3 px-4">
          <div className="w-[185px] h-[185px] flex justify-center items-center bg-indigo-600 rounded-full">
            <img
              src={
                data.user_info.avatar
                  ? `https://api.myunibest.com/${data.user_info.avatar}`
                  : avatar
              }
              className="rounded-full w-[150px] h-[150px] object-cover z-10"
              alt=""
            />
          </div>

          <div className="w-full flex flex-col items-center gap-2 border-b border-indigo-300 pb-3">
            <h1 className="text-2xl font-medium text-gray-800">
              {data.user.name + " " + data.user.family_name}
            </h1>
            <span className="text-indigo-600 text-sm font-medium">
              {data.job_info?.title}
            </span>
          </div>

          <div className="flex flex-col gap-2 items-center text-sm text-gray-600">
            <span>متولد : {toFarsiNumber(data.user_info.birth)}</span>
            <span>وضعیت سربازی : {data.basic_info?.army?.name}</span>
          </div>

          {/* خلاصه رزومه */}
          <div className="flex flex-col items-center gap-3 mt-8">
            <h2 className="text-gray-800 font-medium text-[17px]">
              خلاصه رزومه
            </h2>
            <p className="text-sm text-gray-600">{data.description}</p>
          </div>

          {/* اطلاعات تماس */}
          <div className="w-full flex flex-col gap-3 mt-8">
            <h2 className="text-gray-800 font-medium self-center text-[17px]">
              اطلاعات تماس
            </h2>

            {/* ایمیل */}
            <div className="flex items-center text-gray-600 gap-5">
              <div className="w-10 h-10 bg-indigo-500 rounded-tr-[20px] rounded-bl-[20px] flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#fff"
                  className="w-5 h-5"
                >
                  <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                  <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                </svg>
              </div>

              <span>{data.user_info.email}</span>
            </div>

            {/* شماره تماس */}
            <div className="flex items-center text-gray-600 gap-5 mt-1">
              <div className="w-10 h-10 bg-indigo-500 rounded-tr-[20px] rounded-bl-[20px] flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#fff"
                  className="w-5 h-5"
                >
                  <path d="M10.5 18.75a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z" />
                  <path
                    fillRule="evenodd"
                    d="M8.625.75A3.375 3.375 0 005.25 4.125v15.75a3.375 3.375 0 003.375 3.375h6.75a3.375 3.375 0 003.375-3.375V4.125A3.375 3.375 0 0015.375.75h-6.75zM7.5 4.125C7.5 3.504 8.004 3 8.625 3H9.75v.375c0 .621.504 1.125 1.125 1.125h2.25c.621 0 1.125-.504 1.125-1.125V3h1.125c.621 0 1.125.504 1.125 1.125v15.75c0 .621-.504 1.125-1.125 1.125h-6.75A1.125 1.125 0 017.5 19.875V4.125z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>

              <span>{toFarsiNumber(data.user.phone_number)}</span>
            </div>

            {/* آدرس */}
            <div className="flex items-center text-sm text-gray-500 gap-5 mt-1">
              <div className="min-w-[40px] h-10 bg-indigo-500 rounded-tr-[20px] rounded-bl-[20px] flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#fff"
                  className="w-5 h-5"
                >
                  <path
                    fillRule="evenodd"
                    d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>

              <span>
                {user.info?.province_id?.name}, {user.info?.city_id?.name},{" "}
                {user.info?.address}
              </span>
            </div>
          </div>

          {/* مهارت ها */}
          <div className="w-full flex flex-col gap-3 mt-8">
            <h2 className="text-gray-800 font-medium self-center text-[17px]">
              مهارت ها
            </h2>

            {data.skills?.length > 0
              ? data.skills?.map((skill) => (
                  <div className="text-[15px] flex justify-between items-center text-gray-600">
                    <span>{skill.title}</span>
                    <div className="w-36 h-4 rounded-xl border border-indigo-500">
                      <div
                        style={{ width: `${Number(skill.level.code) * 25}%` }}
                        className="h-full bg-indigo-500 rounded-xl"
                      ></div>
                    </div>
                  </div>
                ))
              : "مهارتی ثبت نشده است"}
          </div>
        </div>

        {/* right side */}
        <div className="col-span-4 mt-28 px-10">
          <div className="w-full flex flex-col gap-10 items-center">
            {/* سوابق تحصیلی */}
            <div className="w-full flex flex-col gap-3">
              <div className="w-full h-10 bg-indigo-500 rounded-tr-full rounded-bl-full flex justify-center items-center text-white">
                سوابق تحصیلی
              </div>

              <ul className="multi-line relative flex flex-col gap-8 -mr-3 pr-3 border-r-2 border-indigo-500">
                {data.edu_info?.length > 0
                  ? data.edu_info?.map((edu) => (
                      <li>
                        <div className="educational-records relative flex flex-col gap-2 text-sm text-gray-500">
                          <h2 className="text-base text-gray-700">
                            {edu.title}
                          </h2>
                          <span className="text-indigo-600">
                            مقطع تحصیلی: {edu.grade.name}
                          </span>
                          <span>موسسه/دانشگاه: {edu.college_name}</span>
                        </div>
                      </li>
                    ))
                  : "اطلاعات تحصیلی ثبت نشده!"}
              </ul>
            </div>

            {/* سوابق شغلی */}
            <div className="w-full flex flex-col gap-3">
              <div className="w-full h-10 bg-indigo-500 rounded-tr-full rounded-bl-full flex justify-center items-center text-white">
                سوابق شغلی
              </div>

              <ul className="multi-line relative flex flex-col gap-8 -mr-3 pr-3 border-r-2 border-indigo-500">
                {data.past_jobs?.length > 0
                  ? data.past_jobs?.map((job) => (
                      <li>
                        <div className="educational-records relative flex flex-col gap-2 text-sm text-gray-500">
                          <h2 className="text-base text-gray-700">
                            {job.title}
                          </h2>
                          <span>نام شرکت: {job.company_name}</span>
                          <span className="text-indigo-600">
                            <span>
                              {job.start_date
                                ? new Intl.DateTimeFormat("fa-IR", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  }).format(new Date(job.start_date))
                                : "ثبت نشده"}{" "}
                              -{" "}
                              {job.end_date && !job.working
                                ? new Intl.DateTimeFormat("fa-IR", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  }).format(new Date(job.end_date))
                                : "مشغول به کار"}
                            </span>
                          </span>
                          <span className="font-semibold text-indigo-600">
                            توضیحات
                          </span>
                          <p className="">{job.description}</p>
                        </div>
                      </li>
                    ))
                  : "سوابق شغلی ثبت نشده"}
              </ul>
            </div>

            {/* زبان */}
            <div className="w-full flex flex-col gap-3">
              <div className="w-full h-10 bg-indigo-500 rounded-tr-full rounded-bl-full flex justify-center items-center text-white">
                زبان
              </div>

              <div className="flex flex-col gap-7">
                {data.langs?.length > 0
                  ? data.langs?.map((lang) => (
                      <div className="flex flex-col gap-4">
                        <span className="text-gray-700 text-lg">
                          {lang.title}
                        </span>

                        <div className="grid grid-cols-4 gap-4">
                          <div className="flex flex-col gap-2 text-indigo-600 text-[13px]">
                            <div
                              style={{
                                background: `conic-gradient(#4d5bf9 ${
                                  (360 * Number(lang.level.code) * 25) / 100
                                }deg,rgb(224 231 255) 0deg)`,
                              }}
                              class="circular-progress"
                            >
                              <div class="value-container relative text-lg">
                                {toFarsiNumber(Number(lang.level.code) * 25)}%
                              </div>
                            </div>
                            <span>مهارت خواندن</span>
                          </div>

                          <div className="flex flex-col gap-2 text-indigo-600 text-[13px]">
                            <div
                              style={{
                                background: `conic-gradient(#4d5bf9 ${
                                  (360 * Number(lang.level.code) * 25) / 100
                                }deg,rgb(224 231 255) 0deg)`,
                              }}
                              class="circular-progress"
                            >
                              <div class="value-container relative text-lg">
                                {toFarsiNumber(Number(lang.level.code) * 25)}%
                              </div>
                            </div>
                            <span>مهارت نوشتن</span>
                          </div>

                          <div className="flex flex-col gap-2 text-indigo-600 text-[13px]">
                            <div
                              style={{
                                background: `conic-gradient(#4d5bf9 ${
                                  (360 * Number(lang.level.code) * 25) / 100
                                }deg,rgb(224 231 255) 0deg)`,
                              }}
                              class="circular-progress"
                            >
                              <div class="value-container relative text-lg">
                                {toFarsiNumber(Number(lang.level.code) * 25)}%
                              </div>
                            </div>
                            <span>مهارت گفتاری</span>
                          </div>

                          <div className="flex flex-col gap-2 text-indigo-600 text-[13px]">
                            <div
                              style={{
                                background: `conic-gradient(#4d5bf9 ${
                                  (360 * Number(lang.level.code) * 25) / 100
                                }deg,rgb(224 231 255) 0deg)`,
                              }}
                              class="circular-progress"
                            >
                              <div class="value-container relative text-lg">
                                {toFarsiNumber(Number(lang.level.code) * 25)}%
                              </div>
                            </div>
                            <span>مهارت شنیداری</span>
                          </div>
                        </div>
                      </div>
                    ))
                  : "زبان ثبت نشده است"}
              </div>
            </div>

            {/* دوره‌ ها و گواهینامه‌ ها */}
            <div className="w-full flex flex-col gap-3">
              <div className="w-full h-10 bg-indigo-500 rounded-tr-full rounded-bl-full flex justify-center items-center text-white">
                دوره‌ ها و گواهینامه‌ ها
              </div>

              <ul className="multi-line relative flex flex-col gap-8 -mr-3 pr-3 border-r-2 border-indigo-500">
                {data.courses?.length > 0
                  ? data.courses?.map((course) => (
                      <li>
                        <div className="educational-records relative flex flex-col gap-2 text-sm text-gray-500">
                          <h2 className="text-base text-gray-700">
                            {course.title}
                          </h2>
                          <p>{course.description}</p>

                          <span className="text-indigo-600">
                            {course.start_date
                              ? new Intl.DateTimeFormat("fa-IR", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                }).format(new Date(course.start_date))
                              : "ثبت نشده"}{" "}
                            -{" "}
                            {course.end_date && !course.working
                              ? new Intl.DateTimeFormat("fa-IR", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                }).format(new Date(course.end_date))
                              : "دوره درحال برگذاری است"}
                          </span>
                        </div>
                      </li>
                    ))
                  : "سوابق شغلی ثبت نشده"}
              </ul>
            </div>

            {/* پروژه ها */}
            <div className="w-full flex flex-col gap-3">
              <div className="w-full h-10 bg-indigo-500 rounded-tr-full rounded-bl-full flex justify-center items-center text-white">
                پروژه ها
              </div>

              <ul className="multi-line relative flex flex-col gap-8 -mr-3 pr-3 border-r-2 border-indigo-500">
                {data.projects?.length > 0
                  ? data.projects?.map((project) => (
                      <li>
                        <div className="educational-records relative flex flex-col gap-2 text-sm text-gray-500">
                          <h2 className="text-base text-gray-700">
                            {project.title}
                          </h2>
                          <p>{project.description}</p>
                          <span className="text-indigo-600">
                            {project.start_date
                              ? new Intl.DateTimeFormat("fa-IR", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                }).format(new Date(project.start_date))
                              : "ثبت نشده"}{" "}
                            -{" "}
                            {project.end_date && !project.working
                              ? new Intl.DateTimeFormat("fa-IR", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                }).format(new Date(project.end_date))
                              : "درحال انجام"}
                          </span>
                          <div className="flex gap-2 items-center">
                            <span>لینک پروژه :</span>
                            <a href={project.link} className="text-indigo-600">
                            {project.link}
                            </a>
                          </div>
                        </div>
                      </li>
                    ))
                  : "پروژه ای ثبت نشده است"}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeTwo;
